/**
 * T-176 — la liste des devis ne s'arrête plus au 50e.
 * `GET /api/metier/devis` pagine (limit ≤ 200, skip) et sert 50 devis par défaut : la grille installateur (OMV, Climat) et TEF
 * filtre ensuite côté navigateur, donc tout filtre ne cherchait que parmi les 50 plus récents. Cette fonction lit TOUTES les pages,
 * dans l'ordre serveur (created_at DESC), puis rend la liste complète ; le tri, la sélection et les actions de la grille ne changent pas.
 * `chargerPage({ limit, skip })` rend un tableau, ou `null` si le serveur a refusé : ⛔ jamais une liste partielle présentée comme complète.
 */
export const TAILLE_PAGE_DEVIS = 200;      // plafond du serveur (Query le=200)
export const PLAFOND_DEVIS = 10000;        // garde-fou : au-delà, la liste est déclarée tronquée

export async function chargerTousLesDevis(chargerPage) {
  const vus = new Set();
  const items = [];
  for (let skip = 0; skip < PLAFOND_DEVIS; skip += TAILLE_PAGE_DEVIS) {
    const page = await chargerPage({ limit: TAILLE_PAGE_DEVIS, skip });
    if (!Array.isArray(page)) return { items: skip === 0 ? null : items, incomplet: true, tronque: false };
    for (const d of page) {
      const cle = d && d.id != null ? String(d.id) : null;
      if (cle !== null && vus.has(cle)) continue;       // une page qui glisse ne doit pas dupliquer une ligne
      if (cle !== null) vus.add(cle);
      items.push(d);
    }
    if (page.length < TAILLE_PAGE_DEVIS) return { items, incomplet: false, tronque: false };
  }
  return { items, incomplet: false, tronque: true };
}
